import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '@/auth/context/AuthContext'
import { esSoloVentasRegistros, TABS_VENTAS_REGISTROS } from '../lib/acceso'

interface Props {
  /** Clave de la pestaña que envuelve este guard (ej. 'resumen', 'canjes'). */
  tab: string
  children: React.ReactNode
}

/**
 * Restringe una pestaña de un reporte de fidelización. Si el usuario tiene el
 * perfil "solo Ventas/Registros" y la pestaña no está permitida, redirige a la
 * pestaña Registros del mismo reporte. En cualquier otro caso renderiza normal.
 */
export function TabFidelizacionGuard({ tab, children }: Props) {
  const { user } = useAuth()
  const { id } = useParams()

  const restringido = esSoloVentasRegistros(user)
  const permitida = TABS_VENTAS_REGISTROS.includes(tab as never)

  if (restringido && !permitida) {
    return <Navigate to={`/reportes-fidelizacion/${id}/registros`} replace />
  }

  return <>{children}</>
}
